import * as React from 'react'
import styles from './footerInfo-style.css'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import Link from '../Link/Link'
import Paragraph from '../Paragraph/Paragraph'
type Props = {
  infoLinks?: Array<LinkViewModel>
  info?: string
}

function FooterInfo({ info, infoLinks }: Props) {
  return (
    <div className={styles.footerInfo}>
      {info && (
        <Paragraph marginBottom={'normal'} tag={'p'} className={styles.address}>
          {info}
        </Paragraph>
      )}

      <div className={styles.infoLinksWrapper}>
        {infoLinks &&
          infoLinks.map((link) => (
            <Link key={link.href} {...link} className={styles.internalLink}>
              {link.label}
            </Link>
          ))}
      </div>
    </div>
  )
}

FooterInfo.displayName = 'FooterInfo'
FooterInfo.defaultProps = {}
export default FooterInfo